// source: witbooking/backoffice/webmessage/v1/webmessage_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.BookingWindow', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.WebMessage', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.WebMessagePositionType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.WebMessageTranslation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.web_message.v1.WebMessageType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.displayName = 'proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.displayName = 'proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest.displayName = 'proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.displayName = 'proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.displayName = 'proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.displayName = 'proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.displayName = 'proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.displayName = 'proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.displayName = 'proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.displayName = 'proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.BookingWindow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.BookingWindow.displayName = 'proto.witbooking.backoffice.web_message.v1.BookingWindow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.WebMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.web_message.v1.WebMessage.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.WebMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.WebMessage.displayName = 'proto.witbooking.backoffice.web_message.v1.WebMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.web_message.v1.WebMessageTranslation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.displayName = 'proto.witbooking.backoffice.web_message.v1.WebMessageTranslation';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest}
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest;
  return proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest}
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest} returns this
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    webMessage: (f = msg.getWebMessage()) && proto.witbooking.backoffice.web_message.v1.WebMessage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse}
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse;
  return proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse}
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.web_message.v1.WebMessage;
      reader.readMessage(value,proto.witbooking.backoffice.web_message.v1.WebMessage.deserializeBinaryFromReader);
      msg.setWebMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebMessage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.web_message.v1.WebMessage.serializeBinaryToWriter
    );
  }
};


/**
 * optional WebMessage web_message = 1;
 * @return {?proto.witbooking.backoffice.web_message.v1.WebMessage}
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.prototype.getWebMessage = function() {
  return /** @type{?proto.witbooking.backoffice.web_message.v1.WebMessage} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.web_message.v1.WebMessage, 1));
};


/**
 * @param {?proto.witbooking.backoffice.web_message.v1.WebMessage|undefined} value
 * @return {!proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse} returns this
*/
proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.prototype.setWebMessage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse} returns this
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.prototype.clearWebMessage = function() {
  return this.setWebMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.prototype.hasWebMessage = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest}
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest;
  return proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest}
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    webMessagesList: jspb.Message.toObjectList(msg.getWebMessagesList(),
    proto.witbooking.backoffice.web_message.v1.WebMessage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse}
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse;
  return proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse}
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.web_message.v1.WebMessage;
      reader.readMessage(value,proto.witbooking.backoffice.web_message.v1.WebMessage.deserializeBinaryFromReader);
      msg.addWebMessages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.web_message.v1.WebMessage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated WebMessage web_messages = 1;
 * @return {!Array<!proto.witbooking.backoffice.web_message.v1.WebMessage>}
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.prototype.getWebMessagesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.web_message.v1.WebMessage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.web_message.v1.WebMessage, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.web_message.v1.WebMessage>} value
 * @return {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse} returns this
*/
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.prototype.setWebMessagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.WebMessage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage}
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.prototype.addWebMessages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.web_message.v1.WebMessage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse} returns this
 */
proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.prototype.clearWebMessagesList = function() {
  return this.setWebMessagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    webMessage: (f = msg.getWebMessage()) && proto.witbooking.backoffice.web_message.v1.WebMessage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest;
  return proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.web_message.v1.WebMessage;
      reader.readMessage(value,proto.witbooking.backoffice.web_message.v1.WebMessage.deserializeBinaryFromReader);
      msg.setWebMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebMessage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.web_message.v1.WebMessage.serializeBinaryToWriter
    );
  }
};


/**
 * optional WebMessage web_message = 1;
 * @return {?proto.witbooking.backoffice.web_message.v1.WebMessage}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.prototype.getWebMessage = function() {
  return /** @type{?proto.witbooking.backoffice.web_message.v1.WebMessage} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.web_message.v1.WebMessage, 1));
};


/**
 * @param {?proto.witbooking.backoffice.web_message.v1.WebMessage|undefined} value
 * @return {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest} returns this
*/
proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.prototype.setWebMessage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest} returns this
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.prototype.clearWebMessage = function() {
  return this.setWebMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest.prototype.hasWebMessage = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    webMessage: (f = msg.getWebMessage()) && proto.witbooking.backoffice.web_message.v1.WebMessage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse;
  return proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.web_message.v1.WebMessage;
      reader.readMessage(value,proto.witbooking.backoffice.web_message.v1.WebMessage.deserializeBinaryFromReader);
      msg.setWebMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebMessage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.web_message.v1.WebMessage.serializeBinaryToWriter
    );
  }
};


/**
 * optional WebMessage web_message = 1;
 * @return {?proto.witbooking.backoffice.web_message.v1.WebMessage}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.prototype.getWebMessage = function() {
  return /** @type{?proto.witbooking.backoffice.web_message.v1.WebMessage} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.web_message.v1.WebMessage, 1));
};


/**
 * @param {?proto.witbooking.backoffice.web_message.v1.WebMessage|undefined} value
 * @return {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse} returns this
*/
proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.prototype.setWebMessage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse} returns this
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.prototype.clearWebMessage = function() {
  return this.setWebMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.prototype.hasWebMessage = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    webMessage: (f = msg.getWebMessage()) && proto.witbooking.backoffice.web_message.v1.WebMessage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest}
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest;
  return proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest}
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.web_message.v1.WebMessage;
      reader.readMessage(value,proto.witbooking.backoffice.web_message.v1.WebMessage.deserializeBinaryFromReader);
      msg.setWebMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebMessage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.web_message.v1.WebMessage.serializeBinaryToWriter
    );
  }
};


/**
 * optional WebMessage web_message = 1;
 * @return {?proto.witbooking.backoffice.web_message.v1.WebMessage}
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.prototype.getWebMessage = function() {
  return /** @type{?proto.witbooking.backoffice.web_message.v1.WebMessage} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.web_message.v1.WebMessage, 1));
};


/**
 * @param {?proto.witbooking.backoffice.web_message.v1.WebMessage|undefined} value
 * @return {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest} returns this
*/
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.prototype.setWebMessage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest} returns this
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.prototype.clearWebMessage = function() {
  return this.setWebMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest.prototype.hasWebMessage = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse}
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse;
  return proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse}
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest}
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest;
  return proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest}
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest} returns this
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse}
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse;
  return proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse}
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.BookingWindow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.BookingWindow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: (f = msg.getStart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endInclusive: (f = msg.getEndInclusive()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.BookingWindow}
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.BookingWindow;
  return proto.witbooking.backoffice.web_message.v1.BookingWindow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.BookingWindow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.BookingWindow}
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStart(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndInclusive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.BookingWindow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.BookingWindow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndInclusive();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp start = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.prototype.getStart = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.web_message.v1.BookingWindow} returns this
*/
proto.witbooking.backoffice.web_message.v1.BookingWindow.prototype.setStart = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.web_message.v1.BookingWindow} returns this
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.prototype.clearStart = function() {
  return this.setStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.prototype.hasStart = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_inclusive = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.prototype.getEndInclusive = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.web_message.v1.BookingWindow} returns this
*/
proto.witbooking.backoffice.web_message.v1.BookingWindow.prototype.setEndInclusive = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.web_message.v1.BookingWindow} returns this
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.prototype.clearEndInclusive = function() {
  return this.setEndInclusive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.web_message.v1.BookingWindow.prototype.hasEndInclusive = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.WebMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.WebMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    positionType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    bookingWindowPeriod: (f = msg.getBookingWindowPeriod()) && proto.witbooking.backoffice.web_message.v1.BookingWindow.toObject(includeInstance, f),
    unlockCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    showOnlyOnUnavailable: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.WebMessage;
  return proto.witbooking.backoffice.web_message.v1.WebMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.WebMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 3:
      var value = /** @type {!proto.witbooking.backoffice.web_message.v1.WebMessagePositionType} */ (reader.readEnum());
      msg.setPositionType(value);
      break;
    case 4:
      var value = /** @type {!proto.witbooking.backoffice.web_message.v1.WebMessageType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.web_message.v1.BookingWindow;
      reader.readMessage(value,proto.witbooking.backoffice.web_message.v1.BookingWindow.deserializeBinaryFromReader);
      msg.setBookingWindowPeriod(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnlockCode(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowOnlyOnUnavailable(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.web_message.v1.WebMessageTranslation;
      reader.readMessage(value,proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.WebMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.WebMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getPositionType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getBookingWindowPeriod();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.backoffice.web_message.v1.BookingWindow.serializeBinaryToWriter
    );
  }
  f = message.getUnlockCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getShowOnlyOnUnavailable();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage} returns this
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool active = 2;
 * @return {boolean}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage} returns this
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional WebMessagePositionType position_type = 3;
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessagePositionType}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.getPositionType = function() {
  return /** @type {!proto.witbooking.backoffice.web_message.v1.WebMessagePositionType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.WebMessagePositionType} value
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage} returns this
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.setPositionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional WebMessageType type = 4;
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessageType}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.getType = function() {
  return /** @type {!proto.witbooking.backoffice.web_message.v1.WebMessageType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.WebMessageType} value
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage} returns this
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional BookingWindow booking_window_period = 5;
 * @return {?proto.witbooking.backoffice.web_message.v1.BookingWindow}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.getBookingWindowPeriod = function() {
  return /** @type{?proto.witbooking.backoffice.web_message.v1.BookingWindow} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.web_message.v1.BookingWindow, 5));
};


/**
 * @param {?proto.witbooking.backoffice.web_message.v1.BookingWindow|undefined} value
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage} returns this
*/
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.setBookingWindowPeriod = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage} returns this
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.clearBookingWindowPeriod = function() {
  return this.setBookingWindowPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.hasBookingWindowPeriod = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string unlock_code = 6;
 * @return {string}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.getUnlockCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage} returns this
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.setUnlockCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool show_only_on_unavailable = 7;
 * @return {boolean}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.getShowOnlyOnUnavailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage} returns this
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.setShowOnlyOnUnavailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * repeated WebMessageTranslation translations = 8;
 * @return {!Array<!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation>}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.web_message.v1.WebMessageTranslation, 8));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation>} value
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage} returns this
*/
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation}
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.witbooking.backoffice.web_message.v1.WebMessageTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessage} returns this
 */
proto.witbooking.backoffice.web_message.v1.WebMessage.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation}
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.web_message.v1.WebMessageTranslation;
  return proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation}
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation} returns this
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation} returns this
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.web_message.v1.WebMessageTranslation} returns this
 */
proto.witbooking.backoffice.web_message.v1.WebMessageTranslation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.web_message.v1.WebMessagePositionType = {
  INVALID_WEB_MESSAGE_POSITION_TYPE: 0,
  TOP_INVENTORY_STEP_1: 1,
  BELOW_LOGO_STEP_1: 2,
  BELOW_PERSONAL_INFO_STEP_2: 3,
  TOP_METHOD_PAYMENT_STEP_2: 4,
  MODAL_STEP_1: 5,
  MODAL_STEP_2: 6,
  CONFIRMATION_PAGE: 7
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.web_message.v1.WebMessageType = {
  INVALID_WEB_MESSAGE_TYPE: 0,
  INFO: 1,
  NOTICE: 2,
  ERROR: 3,
  SUCCESS: 4
};

goog.object.extend(exports, proto.witbooking.backoffice.web_message.v1);
